import React from 'react';
import { Router, Route, Switch, Redirect} from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import HomePage from '../components/HomePage';
import AboutPage from '../components/AboutPage';
import WorkPage from '../components/WorkPage';
import WorkDetailsPage from '../components/WorkDetailsPage';
import ContactPage from '../components/ContactPage';
import NotFoundPage from '../components/NotFoundPage';
import posed, { PoseGroup } from 'react-pose';

const RouteContainer = posed.div();

export const history = createHistory();
if(!history.location.state){
  history.location.state ={
    prevPath:"/",
  };
}


//console.log("history " + history.location.pathname)
let pageName = () =>{
  if(history.location.pathname === "/"){
    return "animate inHome";
  } else {
    return history.location.pathname.replace("/", "animate ");
  }
}


const AppRouter = () => (
  <Router history={history}>
  <Route
    render={ ({ location }) => (
    <div>
    <Header />
    <PoseGroup>
      <RouteContainer  key={location.key? location.key : "root"} className={pageName()}>
        <Switch location={location}>
          <Route key="home" path="/" component={HomePage} exact={true}/>
          <Route key="about" path="/about" component={AboutPage} />
          <Route key="workdetails" path="/work/:id" component={WorkDetailsPage} />
          <Route key="work" path="/work" component={WorkPage}  />
          <Route key="contact" path="/contact" component={ContactPage} />
          <Route key="notfound" path='/' component={NotFoundPage} />
        </Switch>
      </RouteContainer>
      </PoseGroup>
      <MobileNav />
    </div>
    )}
  />
  </Router>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js